import { combineReducers } from "redux";
import { authReducer } from "./slice/authSlice";
import { signReducer } from "./slice/signSlice";
import { otpAuthReducer } from "./slice/otpAuthSlice";
import { feedbackReducer } from "./slice/feedbackSlice";
import { guestReducer } from "./slice/guestAuthSlice";
import { chatSessionReducer } from "./slice/chatSessionSlice";
import { chatSessionHistoryReducer } from "./slice/chatSessionHistorySlice";
import { chatReducer } from "./slice/chatSlice";
import { userProfileReducer } from "./slice/userProfileSlice";
import viewReducer from "./slice/viewSlice";
import { deleteAccountReducer } from "./slice/deleteAccountSlice";
import { deleteChatReducer } from "./slice/deleteChatSlice";
import sideMenuReducer from "./slice/sideMenuSlice";
import { renameTitleReducer } from "./slice/renameTitleSlice";
import { deleteChatSessionReducer } from "./slice/deleteChatSessionSlice";
import { getBookmarkReducer } from "./slice/getBookmarkSlice";
import { createBookmarkReducer } from "./slice/createBookmarkSlice";
import { deleteBookmarkReducer } from "./slice/deleteBookmarkSlice";
import { updateBookmarkReducer } from "./slice/updateBookmarkSlice";

import { patientContextReducer } from "./slice/patientContextSlice";
import { consentReducer } from "./slice/consentSlice";

export const rootReducer = combineReducers({
    guest: guestReducer,
    auth: authReducer,
    sign: signReducer,
    otpAuth: otpAuthReducer,
    feedback: feedbackReducer,
    chatsession: chatSessionReducer,
    fetchsession: chatSessionHistoryReducer,
    fetchBookmarks: getBookmarkReducer,
    createBookmark: createBookmarkReducer,
    deleteBookmark: deleteBookmarkReducer,
    renameBoookmark: updateBookmarkReducer,
    chat: chatReducer,
    profile: userProfileReducer,
    view: viewReducer,
    accountdelete: deleteAccountReducer,
    chatdelete: deleteChatReducer,
    sideMenu: sideMenuReducer,
    renameTitle: renameTitleReducer,
    chatsessiondelete: deleteChatSessionReducer,
    patientContext: patientContextReducer,
    consent: consentReducer
});

export type RootState = ReturnType<typeof rootReducer>;
